// extracted by mini-css-extract-plugin
export default {"homeFAQ":"HomeFAQ_homeFAQ__G28La","button":"HomeFAQ_button__9HE8w"};